import ScrollReveal from '@/components/base/ScrollReveal';

const trustItems = [
  {
    icon: 'ri-shield-check-line',
    title: '316L Steel + PVD Plating',
    desc: 'Surgical-grade stainless steel with premium gold-tone PVD coating that bonds at the molecular level.',
  },
  {
    icon: 'ri-drop-line',
    title: 'Sweat-Proof & Water-Resistant',
    desc: 'Engineered to withstand sweat, light water exposure, and daily wear without tarnishing.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Nickel-Free & Hypoallergenic',
    desc: 'Safe for sensitive skin. No nickel, no lead, no irritation — just pure comfort.',
  },
  {
    icon: 'ri-gift-line',
    title: 'Premium Gift-Ready Packaging',
    desc: 'Every piece arrives in a magnetic gift box with anti-tarnish pouch — ready to gift or keep.',
  },
];

export default function WhyJoviaa() {
  return (
    <section id="why-joviaa" className="bg-primary-500 py-14 md:py-20">
      <div className="max-w-none mx-auto px-4 md:px-6">
        <ScrollReveal>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 text-center mb-10 md:mb-14">
            Why Joviaa
          </h2>
        </ScrollReveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {trustItems.map((item, idx) => (
            <ScrollReveal key={item.title} delay={idx * 120}>
              <div className="text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-accent-500/20 flex items-center justify-center mx-auto mb-4">
                  <div className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center">
                    <i className={`${item.icon} text-xl md:text-2xl text-accent-500`}></i>
                  </div>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-background-50 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-background-50/60 font-label leading-relaxed max-w-xs mx-auto">
                  {item.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}